import Link from 'next/link'
import React, { useEffect, useState } from 'react'
import { UrlObject } from 'url'
import { IBreadcrumb, IWebMenu } from '../../interfaces/webMenu'
import { findMenuItem, urlObjectFactoryForWebmenus } from '../../utils/webmenus'

interface IBreadcrumbsProps {
  activePage: IWebMenu
  webmenus: any
}

interface IBreadcrumbData {
  urlObject: UrlObject
  label: string
  maskedUrl: string
}

const Breadcrumbs: React.FC<IBreadcrumbsProps> = ({ activePage, webmenus }) => {
  const { breadcrumbs_HU, breadcrumbs_EN } = activePage
  const [breadcrumbs, setBreadcrumbs] = useState<IBreadcrumbData[]>([])

  useEffect(() => {
    const breadcrumbsMapCallback = (item: IBreadcrumb) => {
      const { url, text } = item
      const webmenu = findMenuItem(webmenus, `${url[0] === '/' ? '' : '/'}${url}`)
      const { urlObject } = urlObjectFactoryForWebmenus(webmenu)

      return {
        label: text,
        maskedUrl: url,
        urlObject,
      }
    }
    const urlObjects = breadcrumbs_HU.map(breadcrumbsMapCallback)
    setBreadcrumbs(urlObjects)
  }, [activePage, breadcrumbs_HU, breadcrumbs_EN, webmenus])

  const shouldAddDivider = (arrayLength: number, indexOfItem: number) => {
    const hasMoreThanOneItem = arrayLength > 1
    const isNotTheListItem = indexOfItem !== arrayLength - 1
    return hasMoreThanOneItem && isNotTheListItem
  }
  const createBreadcrumbComponents = (
    item: IBreadcrumbData,
    index: number,
    items: IBreadcrumbData[]
  ) => {
    const { label, maskedUrl, urlObject } = item

    return (
      <span key={item.label}>
        <Link key={label} href={urlObject} as={maskedUrl} className=''>
          <a>{label}</a>
        </Link>
        {!!shouldAddDivider(items.length, index) && <span>/</span>}
      </span>
    )
  }

  return (
    <div className='h-24 text-breadcrumb-color w-full gap-desktop font-montserrat text-breadcrumb'>
      <div className='w-full xl:w-2/3'>
        <Link key={'HOME'} href={'/'} className=''>
          <a>Főoldal</a>
        </Link>
        {!!breadcrumbs?.length && <span>/</span>}
        {breadcrumbs.map(createBreadcrumbComponents)}
      </div>
    </div>
  )
}

export default Breadcrumbs
